import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Form, Button, Card, Alert } from "react-bootstrap";
import AuthContext from "../context/AuthContext";

const API_URL = process.env.REACT_APP_API_URL;

const Login = () => {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false); // State for checkbox
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const response = await axios.post(`${API_URL}/auth/login`, {
        user,
        password,
        rememberMe, // Include rememberMe in the request
      });

      login(response.data);

      navigate("/"); // Chuyển hướng về trang chủ
    } catch (err) {
      setError(err.response?.data || "Đã xảy ra lỗi. Vui lòng thử lại.");
    }
  };
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: "80vh" }}
    >
      <Card style={{ width: "25rem" }}>
        <Card.Body>
          <Card.Title className="text-center mb-4">Đăng Nhập</Card.Title>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Tên đăng nhập hoặc Email</Form.Label>
              <Form.Control
                type="text"
                placeholder="Nhập tên đăng nhập"
                value={user}
                onChange={(e) => setUser(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Mật khẩu</Form.Label>
              <Form.Control
                type="password"
                placeholder="Mật khẩu"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicCheckbox">
              <Form.Check
                type="checkbox"
                label="Ghi nhớ đăng nhập"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
            </Form.Group>

            <Button variant="primary" type="submit" className="w-100">
              Đăng Nhập
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Login;
